module.exports = __webpack_public_path__ + "static/img/animales_36.869a6edc.png";